import { render, staticRenderFns } from "./ResellerProducts.vue?vue&type=template&id=6d97d50c&"
import script from "./ResellerProducts.vue?vue&type=script&lang=js&"
export * from "./ResellerProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports